import React from 'react';

import {BlockSkeleton} from '@udemy/react-reveal-components';

import styles from './personal-plan-faq-skeleton.module.less';

/** One placeholder per FAQ accordion row the loaded section typically shows. */
const FAQ_ROWS = ['row-1', 'row-2', 'row-3', 'row-4', 'row-5'];

/**
 * ### PersonalPlanFAQSkeleton
 *
 * Loading state for the FAQ accordion. Five stacked bars that match the loaded
 * question list's width and rhythm so the footer does not jump when it resolves.
 */
export const PersonalPlanFAQSkeleton = () => (
    <div className={styles['wrapper']} data-testid="personal-plan-faq-skeleton">
        {FAQ_ROWS.map((rowKey) => (
            <div key={rowKey} className={styles['row']}>
                <BlockSkeleton className={styles['fill']} />
            </div>
        ))}
    </div>
);
